import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { AppContext } from "../../context/AppContext";
import { useAuth } from "../../auth/AuthContext";

/**
 * @function
 * @name PrivateRoute
 * @description Route which check authentication status and route to appropriate
 *  component
 *
 * @param {object} properties props object
 *
 * @returns {object} React Element
 *
 * @version 0.1.0
 * @since 0.1.0
 */


const PrivateRoute = (properties) => {
  const { component: Component, requiredPermissions, path,  ...rest } = properties;
  const { token } = useAuth();
  const isLogin = () => !!token;

  const {permissions} = useContext (AppContext);

  const hasPermissions = () => {
    if (!requiredPermissions || requiredPermissions.length === 0) return true;
    const userPermissions = permissions;
    const status = requiredPermissions?.every(permission =>
      userPermissions?.includes(permission)
    );
    return status
  };

  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) =>
        isLogin() ? (
          hasPermissions() ? (
            Component ? (
              <Component {...props} />
            ) : (
              rest.render(props)
            )
          ) : (
            <Redirect
              to={{ pathname: "/unauthorized", state: { from: props.location } }}
            />
          )
        ) : (
          <Redirect
            to={{ pathname: "/signin", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

/* props validation */
PrivateRoute.propTypes = {
  component: PropTypes.elementType,
  render: PropTypes.func,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
};

export default PrivateRoute;
